import React from 'react';
import './ScappSwitch.css';

const ScappSwitch = ({ label, ariaLabel, isChecked, onToggle, disabled = false }) => (
  <label className={`switch${disabled ? ' switch-disabled' : ''}`}>
    <input
      type="checkbox"
      checked={isChecked}
      onChange={onToggle}
      disabled={disabled}
      aria-label={ariaLabel || label}
    />
    <span className="slider"></span>
    {label && <span className="switch-label">{label}</span>}
  </label>
);

export default ScappSwitch;
